import cloneDeep from 'lodash.clonedeep';
import {useRefHistory} from '@vueuse/core'

export function useSurfaceEditorStoreStatesManagement({surfaces, project}) {

  const persistence = useSurfaceEditorPersistence({surfaces, project});

  const {
    history,
    undo,
    redo,
    canUndo,
    canRedo,
    pause,
    resume,
    commit,
    clear,
  } = useRefHistory(surfaces, {
    deep: false,
    capacity: 100,
    clone: (v) => cloneDeep(toRaw(v))
  });

  const persist = useDebounceFn(async () => {
    pause();
    try {
      await persistence.persist();
    } catch(e) {
      //todo: handle api errors
      console.log('Need to handle error');
      console.log(e);

    } finally {
      resume();
    }
  }, 500);

  const commitUndoWithPersist = useDebounceFn(async () => {
    commit();
    await persist();
  });

  async function undoWithPersist() {
    undo();
    await persist();
  }
  async function redoWithPersist() {
    redo();
    await persist();
  }

  function clearUndoHistory() {
    clear();
    persistence.reset();
  }

  async function persistNow() {
    pause();
    try {
      await persistence.persist();
    } finally {
      resume();
    }
  }

  return {
    undo: undoWithPersist,
    redo: redoWithPersist,
    canUndo,
    canRedo,
    pauseUndo: pause,
    resumeUndo: resume,
    commitUndo: commitUndoWithPersist,
    persistNow,
    clearUndoHistory
  };
}
